import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const YourBrainOnAI = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >
        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">
          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">
            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Your Brain on AI
            </h1>

            <p
              className="text-lg md:text-xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Why machines aren’t making us stupid — they’re just changing how
              we think
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>
          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Left Column */}
              <div className="max-w-2xl">
                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Every few years, a new wave of anxiety sweeps in with the
                  latest technology: Google is making us forgetful, smartphones
                  are destroying our attention spans, and now AI is supposedly
                  eroding our ability to think. But what if we've got the story
                  backward? From a neuroscientific perspective, these tools are
                  not replacing our thinking — they are extending it. Drawing on
                  cutting-edge research (including studies showing both
                  short-term reductions in engagement and longer-term gains in
                  certain cognitive abilities), <em>Think Before You Think</em>
                  shows us that the evidence is far more nuanced than the
                  headlines suggest. Humans have always offloaded cognitive
                  work, from writing things down on post-it notes to using log
                  tables, slide rules, and then calculators, and modern AI is
                  simply the latest and most powerful example of what
                  philosopher Andy Clark calls the “extended mind”: a system in
                  which brain, body, and environment work together to solve
                  problems.
                </p>
              </div>

              {/* right image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/ai-brain-transparent.png"
                  alt="Your Brain on AI"
                  className="w-full max-w-[600px]"
                />
              </div>
            </div>
            {/* Creyos Test Button */}
            <div className="mt-24 text-center">
              <a
                href="https://habstudy.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
              >
                IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK
                HERE
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YourBrainOnAI;
